import { Box, styled } from '@mui/material';
import IssueTooltip from 'DesignSystem/DataDisplay/ItemIssue/IssueTooltip';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { FC } from 'react';
import FlexBox from 'Components/FlexBox';

interface IItemIssueProps {
  issues: { message: string }[];
  /**
   * Item name to be displayed in the tooltip title e.g. "Plot"
   */
  itemName: string;
  severity: 'error' | 'warning';
}

const NumberCircle = styled(Box)<{ severity?: 'error' | 'warning' }>(({ theme, severity }) => ({
  width: 16,
  height: 16,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background:
    severity === 'error' ? theme.custom.themeColors.error[60] : theme.custom.themeColors.accent[60],
  flexShrink: 0,
}));

const IssueTextContainer = styled(Box)<{ cursor?: string; severity?: 'error' | 'warning' }>(
  ({ theme, cursor, severity }) => ({
    borderRadius: 4,
    padding: '4px 4px',
    background:
      severity === 'error'
        ? theme.custom.themeColors.error[20]
        : theme.custom.themeColors.accent[20],
    cursor,
  })
);

const ItemIssue: FC<IItemIssueProps> = ({ issues, severity, itemName }) => {
  return (
    <FlexBox ml={0.5} gap={0.5} maxWidth="calc(25% - 20px)">
      <NumberCircle severity={severity}>
        <ThemeTypography variant="BODY_SMALL_BOLD" color="GRAY_100">
          {issues.length}
        </ThemeTypography>
      </NumberCircle>
      <IssueTooltip itemName={itemName} issues={issues} severity={severity}>
        <IssueTextContainer
          width={`calc(100% - 20px - ${issues.length > 1 ? '24px' : '0px'})`}
          cursor="default"
          severity={severity}
        >
          <ThemeTypography variant="BODY_SMALL" color="GRAY_100" autoOverflow hideTooltip>
            {issues[0].message}
          </ThemeTypography>
        </IssueTextContainer>
      </IssueTooltip>
      {issues.length > 1 && (
        <IssueTooltip issues={issues} severity={severity} itemName={itemName}>
          <IssueTextContainer cursor="default" severity={severity}>
            <ThemeTypography variant="BODY_SMALL" color="GRAY_100">
              ...
            </ThemeTypography>
          </IssueTextContainer>
        </IssueTooltip>
      )}
    </FlexBox>
  );
};

export default ItemIssue;
